import React from 'react';
import { useHelmet, MetaTag } from '@thd-nucleus/thd-helmet';

const noIndexHandler = () => {

  return new MetaTag({ name: 'ROBOTS', content: 'NOINDEX, NOFOLLOW', id: 'robots' });
};

const NoIndexNoFollowMetadata = () => {

  useHelmet('noIndexMetatag', {}, noIndexHandler, []);

  return null;
};

NoIndexNoFollowMetadata.displayName = 'NoIndexNoFollowMetadata';

NoIndexNoFollowMetadata.propTypes = {
};

export { NoIndexNoFollowMetadata };
